export default __webpack_public_path__ + "static/media/marketing.2e25d893.svg";